import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography, Container, Box, TextField } from '@material-ui/core';
import Layout from '../Layout';
import { useDispatch, useSelector } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CreateDefaultCheckpoints, Createplan } from '../../ReduxStore/CreatePlanSlice';
import { getVendorData } from '../../ReduxStore/VendorDataSlice';




const BulkPVPlan = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' }
    ];
    const { response } = useSelector(state => state.vendor);
    const [progress, setProgress] = useState(0); // Progress tracking
    const [total, setTotal] = useState(0); // Total suppliers count
    // const [running, setRunning] = useState(false); // Track if API process is running
    const [formErrors, setFormErrors] = useState({});
    const [formData, setFormData] = useState({
        frequency: "yearly",
        startDate: ""
    });

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            { key: 'startDate', label: 'Start Date' },
            { key: 'frequency', label: 'Frequency' }
        ];

        requiredFields.forEach(({ key, label }) => {
            if (!formData[key]) {
                newErrors[key] = `${label} is required.`;
            }
        });

        setFormErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    useEffect(() => {
        dispatch(getVendorData());
    }, [dispatch])


    // const createBulkPlans = async () => {
    //     if (!response || !Array.isArray(response) || response.length === 0) {
    //         toast.error("No suppliers found!");
    //         return;
    //     }

    //     if (!validateForm()) {
    //         toast.error("Please fill all required fields.");
    //         return; // Stop submission if validation fails
    //     }

    //     const selectedDate = new Date(formData.startDate);

    //     // Set the time to 12:00:00
    //     selectedDate.setHours(12, 0, 0, 0);

    //     // Extract the date components
    //     const day = String(selectedDate.getDate()).padStart(2, '0');
    //     const month = String(selectedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    //     const year = selectedDate.getFullYear();
    //     const hours = String(selectedDate.getHours()).padStart(2, '0');
    //     const minutes = String(selectedDate.getMinutes()).padStart(2, '0');
    //     const seconds = String(selectedDate.getSeconds()).padStart(2, '0');

    //     // Format the date to "DD/MM/YYYY HH:MM:SS"
    //     const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

    //     let index = 0;
    //     setTotal(response.length);
    //     setProgress(0); // Reset progress bar

    //     while (index < response.length) {
    //         const supplier = response[index];

    //         const newPlan = {
    //             supplier_id: supplier.id,
    //             start_date: formattedDate,
    //             frequency: "yearly",
    //         };

    //         try {
    //             const action = dispatch(Createplan(newPlan));
    //             const res = await action.unwrap();

    //             if (res.StatusCode === 201) {
    //                 console.log(`Plan created successfully for ${supplier.vendor}`);
    //             } else {
    //                 console.error(`Failed to create plan for ${supplier.vendor}`);
    //             }
    //         } catch (error) {
    //             console.error(`Error creating plan for ${supplier.vendor}:`, error);
    //         }

    //         // Update progress
    //         setProgress(prev => prev + 1);
    //         index++; // Move to next supplier
    //     }

    //     toast.success("All plans created successfully!");
    // };

    const createBulkPlans = async () => {
    if (!response || !Array.isArray(response) || response.length === 0) {
        toast.error("No suppliers found!");
        return;
    }

    if (!validateForm()) {
        toast.error("Please fill all required fields.");
        return;
    }

    const selectedDate = new Date(formData.startDate);
    selectedDate.setHours(12, 0, 0, 0);

    const day = String(selectedDate.getDate()).padStart(2, '0');
    const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const year = selectedDate.getFullYear();
    const hours = String(selectedDate.getHours()).padStart(2, '0');
    const minutes = String(selectedDate.getMinutes()).padStart(2, '0');
    const seconds = String(selectedDate.getSeconds()).padStart(2, '0');

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

    let index = 0;
    setTotal(response.length);
    setProgress(0);

    while (index < response.length) {
        const supplier = response[index];

        const newPlan = {
            supplier_id: supplier.id,
            start_date: formattedDate,
            frequency: "yearly",
        };

        try {
            const action = dispatch(Createplan(newPlan));
            const res = await action.unwrap();

            if (res.StatusCode === 201) {
                console.log(`Plan created for ${supplier.vendor}`);

                // ✅ Create Default Checkpoints for each created plan
                const defaultCheckpoints = [
                    {
                        plan_id: res.result.PV_plan.id,
                        check_point: "RFID Tag Present"
                    },
                    {
                        plan_id: res.result.PV_plan.id,
                        check_point: "Physical Damage"
                    }
                ];

                try {
                    const checkpointAction = dispatch(CreateDefaultCheckpoints(defaultCheckpoints));
                    const checkpointRes = await checkpointAction.unwrap();

                    if (checkpointRes.StatusCode === 201) {
                        console.log(`Checkpoints created for ${supplier.vendor}`);
                    }
                } catch (checkpointError) {
                    console.error(`Checkpoint creation failed for ${supplier.vendor}`, checkpointError);
                }

            } else {
                console.warn(`Plan already exists for ${supplier.vendor}`);
            }

        } catch (error) {
            console.error(`Error creating plan for ${supplier.vendor}:`, error);
        }

        setProgress(prev => prev + 1);
        index++;
    }

    toast.success("Bulk plans and checkpoints processed successfully!");
};

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Manage PV Plans" />
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Create Plan for All suppiers
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label="Start Date"
                                name="startDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                error={!!formErrors.startDate}
                                helperText={formErrors.startDate}
                                required
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                                inputProps={{
                                    min: new Date().toISOString().split("T")[0],  // Set min attribute to today's date
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => createBulkPlans()}
                                style={{ marginTop: '10px' }}
                            >
                                Create Plans
                            </Button>
                        </Grid>
                        {/* <Grid item xs={12} sm={2}>
                            {running && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={stopBulkProcess}
                                    style={{ marginTop: '10px' }}
                                >
                                    Stop
                                </Button>
                            )}
                        </Grid> */}
                    </Grid>
                    {total > 0 && (
                        <div style={{ marginTop: "10px" }}>
                            <progress value={progress} max={total} />
                            <p>{progress} out of {total} plans created</p>
                        </div>
                    )}
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default BulkPVPlan;
